import { render } from "./CIS-Resource-Benchmark-List.vue?vue&type=template&id=3df34c80&scoped=true"
import script from "./CIS-Resource-Benchmark-List.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Benchmark-List.vue?vue&type=script&lang=js"

import "./CIS-Resource-Benchmark-List.vue?vue&type=style&index=0&id=3df34c80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df34c80"]])

export default __exports__